import Vue from 'vue';
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)



import en from 'vuetify/src/locale/en'
import et from 'vuetify/src/locale/et'
import uk from 'vuetify/src/locale/uk'

import customEe from "@/plugins/translations/customEt";
import customEn from "@/plugins/translations/customEn";
import customLa from "@/plugins/translations/customLa";
import customRu from "@/plugins/translations/customRu";
import {hildegardEn, hildegardEt, hildegardUk} from "@/plugins/translations/hildegard";
import {gardenEn, gardenEt, gardenUk} from "@/plugins/translations/garden";

const messages = {
    en: {
        hildegardText: hildegardEn,
        gardenText: gardenEn,
        $vuetify: {
            ...en
        },
        ...customEn
    },
    et: {
        hildegardText: hildegardEt,
        gardenText: gardenEt,
        $vuetify: {
            ...et
        },
        ...customEe
    },
    uk: {
        hildegardText: hildegardUk,
        gardenText: gardenUk,
        $vuetify: {
            ...uk
        },
        ...customRu
    },
    la: {
        hildegardText: hildegardEt,
        gardenText: gardenEt,
        $vuetify: {
            ...et
        },
        ...customLa
    },
}

const languages = ["en", "et", "ru", "la"]
const split = window.location.pathname.split("/");
let initialLocale = 'et';

if (split.length >= 2 && languages.includes(split[1])) {
    initialLocale = split[1];
}

const i18n = new VueI18n({
    locale: initialLocale, // set locale
    messages, // set locale messages
});

const t = (key: string) => {
    if (!key) {
        return '';
    }
    return i18n.tc(key);
};

export default i18n;
export {t};